








import { defineComponent, computed } from '@vue/composition-api';
import { OlbIcon } from '@olbbank/vue-components';

/**
 * Totop button with two different skins
 */
export default defineComponent({
	components: {
		OlbIcon,
	},
	props: {
		/**
		 * Invert colors
		 */
		inverted: Boolean,
	},
	setup(props) {
		const classes = computed(() => ['olb-totop', props.inverted && 'olb-totop-inverted']);

		function clickHandler(): void {
			window.scroll({
				behavior: 'smooth',
				left: 0,
				top: 0,
			});
		}

		return { classes, clickHandler };
	},
});
